module.exports = __webpack_public_path__ + "img/map-message-5.64825393.png";